module.exports = __webpack_public_path__ + "static/media/bg1.2dbd441e.jpg";